import React from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SoicalMediaIcon,
  SidebarLink,
} from "./SidebarElements";
import Opensea from '../../images/Opensea.png';
import Instagram from '../../images/Instagram.png';
import Twitter from '../../images/Twitter.png';
import discord from '../../images/Discode.png';

// import { FaTwitter, FaDiscord } from "react-icons/fa";

const Sidebar = ({ isOpen, toggle }) => {
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink
            to="about"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            About
          </SidebarLink>

          <SidebarLink
            to="story"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            Roadmap
          </SidebarLink>

          <SidebarLink
            to="whitepaper"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            White Paper
          </SidebarLink>

          <SidebarLink
            to="faq"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            Faqs
          </SidebarLink>

          <SidebarLink
            to="services"
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
          >
            Team
          </SidebarLink>
          <div style={{ justifyContent: "center", display: "flex" }}>
            <div className="side-bar-menu">
              <SoicalMediaIcon
                href="https://discord.gg/m82m99dUmt"
                target="_blank"
              >
                <img
                  src={discord}
                  style={{ width: 40, height: 40, marginTop: -12 }}
                  alt={"Instagram"}
                />
              </SoicalMediaIcon>
              <SoicalMediaIcon
                href="https://www.instagram.com/trippychciks/"
                target="_blank"
              >
                <img
                  src={Instagram}
                  style={{ width: 40, height: 40, marginTop: -12 }}
                  alt={"Instagram"}
                />
              </SoicalMediaIcon>
              <SoicalMediaIcon
                href="https://twitter.com/chicks_trippy"
                target="_blank"
              >
                <img
                  src={Twitter}
                  style={{ width: 40, height: 40, marginTop: -12 }}
                  alt={"Opensea"}
                />
              </SoicalMediaIcon>

              <SoicalMediaIcon
                href="https://opensea.io/TrippyChicks"
                target="_blank"
              >
                <img
                  src={Opensea}
                  style={{ width: 40, height: 40, marginTop: -12 }}
                  alt={"Opensea"}
                />
              </SoicalMediaIcon>
            </div>
          </div>
        </SidebarMenu>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
